<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="">
                <div class="px-lg-5 pt-lg-5 pb-lg-2">
                    <div class="login-header text-center mb-4">{{ $t('password_recovery') }}</div>
                    <base-alert type="danger" v-if="error">{{error}}</base-alert>
                    <base-alert type="primary mt-5 mb-8" v-if="recoveredMessage">
                        {{ recoveredMessage }}
                    </base-alert>
                    <div role="form" v-if="!recoveredMessage">

                        <base-input class="input-group-alternative mb-3"
                                    :placeholder="`${$t('enter_email')}`"
                                    :error="fieldError('login')"
                                    :disabled="recoveredMessage"
                                    addon-left-icon="ni ni-hat-3"
                                    v-model="login"
                                    @keyup.enter.prevent="submit">
                        </base-input>

                        <div class="text-center">
                            <base-button :disabled="!submitEnabled" class="my-4 px-5 py-3 login-btn" @click="submit">
                                {{ $t('recovery') }}
                            </base-button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="col-12"></div>
        <div class="row mt-3">
            <div class="col-12 text-center other-login">
                <router-link to="/user/signin" class="text-light">
                    {{ $t('do_register') }}
                </router-link>
            </div>
            <div class="col-12 text-center mt-2 other-login">
                <router-link to="/user/signin" class="text-light">
                    {{ $t('login_existing_account') }}
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
    import userApi from "../data/UserApi";

    export default {
        name: 'user-recovery',
        data() {
            return {
                login: '',

                error: null,
                fieldsErrors: [],
                loading: false,

                recoveredMessage: null,
            }
        },

        computed: {
            submitEnabled() {
                return this.login && this.login.length > 0
            },
        },

        mounted() {
        },

        methods: {
            submit() {
                this.error = null
                this.fieldsErrors = []
                this.loading = true
                let returnUrl = null
                if ('return' in this.$route.query) returnUrl = this.$route.query.return
                userApi.simpleRecovery(this.login, returnUrl)
                    .then(response => {
                        this.recoveredMessage = response
                        this.loading = false
                    })
                    .catch(error => {
                        let data = error.response.data
                        if (error.response.status === 422) {
                            this.fieldsErrors = data
                        } else {
                            this.error = this.pretty(data)
                        }
                        this.loading = false
                    })
            },

            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },
            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        }
    }
</script>
<style>
</style>
